<template lang="html">

  <section class="login">
    <div class="pageHeading">
    <h1 style="color: red">Connection Error</h1>
    </div>

    <div>
      <p>Please make sure you are connected to the internet or try again in a few minutes</p>
    <v-progress-linear  :indeterminate="true"></v-progress-linear>
      <span >Attempting to reconnect...</span>
    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'connecting',
    props: [],
    mounted() {
    },
    data() {
      return {
      }
    },
    methods: {
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.login {
}
</style>
